export const onEnterPressed = (e: React.KeyboardEvent, func?: () => void) => {
  if (e.key === "Enter") {
    e.preventDefault();
    func && func();
  }
};
